import React from 'react';
import {cons} from "../../assets/react-css/const";
import {Row} from "reactstrap";
import {NOT_FOUND_MSG} from "../../components/i18n/i18n";
import svg404 from "../../assets/images/logo/svg/404.svg";
import {history} from "../../jwt/_helpers";
import {ButtonReturn} from "../../components/buttons/buttonsActions";

const customStyle = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
};

class Page404 extends React.Component {
    constructor(props) {
        super(props);
    }

    goToMain() {
        history.push('/')
    }

    render() {
        return (
            <div className="auth-wrapper alto" style={cons.emptyBackground}>
                <div className="auth-wrapper  align-items-center d-flex" style={customStyle}>
                    <div className="container">
                        <div>
                            <Row className="justify-content-center">
                                <img height={"50%"} width={"50%"} src={svg404} alt={"404"}/>
                            </Row>
                            <Row className="no-gutters justify-content-center">
                                <h2 className="p-2 text-404 font">
                                    {NOT_FOUND_MSG}
                                </h2>
                            </Row>
                            <Row className="no-gutters justify-content-center">
                                <h2 className="p-2 font-bold">
                                    <ButtonReturn onClick={this.goToMain}/>
                                </h2>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Page404;

